import { render, staticRenderFns } from "./service_goldprice.vue?vue&type=template&id=243182ec&scoped=true"
import script from "./service_goldprice.vue?vue&type=script&lang=js"
export * from "./service_goldprice.vue?vue&type=script&lang=js"
import style0 from "./service_goldprice.vue?vue&type=style&index=0&id=243182ec&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "243182ec",
  null
  
)

export default component.exports